import { render } from "./ManageFriends.vue?vue&type=template&id=e6038f1a&scoped=true"
import script from "./ManageFriends.vue?vue&type=script&lang=js"
export * from "./ManageFriends.vue?vue&type=script&lang=js"

import "./ManageFriends.vue?vue&type=style&index=0&id=e6038f1a&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6038f1a"]])

export default __exports__